/**
 * @desc 库存调整单历史数据锁定库存
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/test/adHistoryLockInventory/`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
